/**
 * Estilos compartilhados para drawers laterais.
 *
 * O HeroUI compõe `Drawer.Dialog` via slot; ao passar `className` customizado,
 * garantimos aqui as classes base do painel (bg-overlay, shadow, BEM) para
 * evitar drawers “em branco” sem o visual padrão.
 *
 * Safe area (PWA iOS): aplicada em `.drawer__content--left/right` via
 * `styles/tokens.css` — o painel fica abaixo da status bar e acima do home
 * indicator, sem precisar de margin-top no dialog (que cortava o rodapé).
 */

const drawerDialogPanelClassName =
  'drawer__dialog bg-overlay text-foreground shadow-overlay';

/** Altura e overflow do painel dentro da área segura do content. */
const drawerPanelLayoutClassName = '!h-full !max-h-full !min-h-0 !overflow-hidden';

/** Painel do assistente: cabe lista + chat no desktop, tela cheia no mobile. */
export const assistantDrawerDialogClassName = [
  drawerDialogPanelClassName,
  'drawer__dialog--right',
  drawerPanelLayoutClassName,
  '!w-full !max-w-full rounded-none',
  'sm:!w-[min(42rem,92vw)] sm:!max-w-[92vw]',
  'md:!w-[min(52rem,92vw)]',
].join(' ');

/** Painel de drawer lateral: largura total no mobile, ~384px a partir de sm. */
export const sideDrawerDialogClassName = [
  drawerDialogPanelClassName,
  'drawer__dialog--right',
  drawerPanelLayoutClassName,
  '!w-full !max-w-full rounded-none',
  'sm:!w-96 sm:!max-w-[85vw]',
].join(' ');

/** Planta da vaga: ocupa a tela inteira para caber zoom e centralização. */
export const fullScreenDrawerDialogClassName = [
  drawerDialogPanelClassName,
  'drawer__dialog--right',
  drawerPanelLayoutClassName,
  'flex flex-col',
  '!w-full !max-w-full rounded-none',
].join(' ');

/** Menu de navegação mobile: mesma largura da sidebar, sem cobrir a tela inteira. */
export const navDrawerDialogClassName = [
  drawerDialogPanelClassName,
  'drawer__dialog--left',
  drawerPanelLayoutClassName,
  '!w-60 !max-w-[85vw] rounded-none',
].join(' ');

/** Corpo padrão dos drawers com formulários ou listas. */
export const drawerBodyClassName = 'flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto';

/** Rodapé padrão dos drawers. */
export const drawerFooterClassName =
  'flex shrink-0 flex-row flex-wrap items-center justify-end gap-2';

/**
 * Campos em drawer (Input, TextArea, Select.Trigger): no dark mode, --field-background
 * coincide com o overlay do painel — borda e superfície explícitas evitam campos “invisíveis”.
 */
export const drawerFieldClassName =
  'border border-separator bg-surface-secondary shadow-none';

/** Alias legado — preferir drawerFieldClassName. */
export const drawerSelectTriggerClassName = drawerFieldClassName;
